import React from 'react';
import DevModeBanner from './DevModeBanner';
import { isDevModeEnabled } from '@/utils/devMode';
import { useLocation } from 'react-router-dom';

/**
 * DevModeWrapper - Unified wrapper for consistent DEV MODE banner handling
 * 
 * The DEV banner only shows on authenticated/internal pages (/app/*, /corvana-crm, /tech-admin)
 * Public pages (landing, register, login, pricing, etc.) do NOT show the banner.
 */
export default function DevModeWrapper({ children }) {
  const devMode = isDevModeEnabled();
  const location = useLocation();
  
  // Only show DevModeBanner on internal/authenticated routes
  const internalRoutes = ['/app', '/corvana-crm', '/tech-admin'];
  const isInternalPage = internalRoutes.some(route => location.pathname.startsWith(route));
  const showDevBanner = devMode && isInternalPage;
  
  return (
    <>
      {/* Only show DEV banner on internal pages */}
      {showDevBanner && <DevModeBanner />}
      
      {/* Main content with automatic offset when dev banner is visible */}
      <div className={showDevBanner ? 'dev-mode-active' : ''}>
        {children}
      </div>
    </>
  );
}

// Export the offset value for components that need to calculate positions
export const DEV_BANNER_HEIGHT = 52;
